<div class="inyova-grow-project-detail">
  <!-- Project Progress -->
  <div class="ds-card project-progress" *ngIf="projectProgress > 10">
    <div class="header">
      <app-ds-icon name="earth"></app-ds-icon>

      <p class="ds-color-core-neutral-10 ds-heading-3">
        {{ 'GROW.projects.progressWidget.title' | translate: { percentage: projectProgress / 100 | percent: '1.0' } }}
      </p>
    </div>
    <app-ds-progress-bar type="info" [percentage]="projectProgress"></app-ds-progress-bar>
    <div class="info-row">
      <p class="ds-ui-3 ds-color-core-neutral-7">
        {{
          'GROW.projects.progressWidget.description'
            | translate
              : {
                  totalAmount: project.volume_secured_from_customers | thousand: project.currency,
                  projectGoal: project.inyova_volume | thousand: project.currency
                }
        }}
      </p>
      <div class="info-icon">
        <app-ds-icon name="info" (click)="toggleInfo('progress')" color="var(--color-core-neutral-7)"></app-ds-icon>
      </div>
    </div>
    <div *ngIf="showInfo['progress']" class="progress-info">
      <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.projects.progressWidget.info' | translate }}</p>
    </div>
  </div>
  <!-- End project progress -->

  <!-- Slot for deposit widget -->
  <ng-content></ng-content>

  <div *ngIf="project.image" class="project-image">
    <img [src]="project.image" alt="Project image" />
  </div>

  <h3 class="ds-title-3">{{ project.title }}</h3>

  <!-- project stage and status -->
  <div class="ds-rows-white">
    <div
      class="ds-row-white"
      [class.only-one-row]="
        isProjectInactive ||
        project.investments.length === 0 ||
        (project.investments.length > 0 && project.investments[0]?.status !== projectStatus.INTERESTED)
      "
    >
      <div class="content">
        <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.project.stage.label' | translate }}</p>
        <div>
          <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.project.stage.' + project.stage + '.name' | translate }}</p>
          <app-ds-icon name="info" (click)="toggleInfo('stage')" color="var(--color-core-neutral-7)"></app-ds-icon>
        </div>
      </div>
      <div *ngIf="showInfo['stage']" class="info">
        <p class="ds-ui-3 ds-color-core-neutral-7">{{ 'GROW.project.stage.' + project.stage + '.infoText' | translate }}</p>
      </div>
    </div>

    @if (project.investments.length > 0 && project.investments[0].status === projectStatus.INTERESTED && !isProjectInactive) {
      <div class="ds-row-white">
        <div class="content">
          <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.project.customerInvestmentStatus.label' | translate }}</p>
          <div>
            <app-ds-badge [type]="getInvestmentBadge(projectStatus.INTERESTED).type">
              {{ 'GROW.project.customerInvestmentStatus.' + getInvestmentBadge(projectStatus.INTERESTED).key + '.name' | translate }}
            </app-ds-badge>
            <app-ds-icon name="info" (click)="toggleInfo('status')" color="var(--color-core-neutral-7)"></app-ds-icon>
          </div>
        </div>
        @if (showInfo['status']) {
          <div class="info">
            <p class="ds-ui-3 ds-color-core-neutral-7">
              {{ 'GROW.project.customerInvestmentStatus.' + getInvestmentBadge(projectStatus.INTERESTED).key + '.infoText' | translate }}
            </p>
          </div>
        }
      </div>
    }
  </div>

  @if (project.investments.length > 0 && project.investments[0].status !== projectStatus.INTERESTED) {
    <div class="inyova-grow-figures">
      <h2 class="ds-heading-1">{{ 'GROW.project.investments.title' | translate }}</h2>

      @for (investment of project.investments; track investment) {
        @let badge = getBadge(investment.status);
        <app-ds-info-row [showCustomContent]="true">
          <ng-template #customContent>
            <div class="inyova-grow-investment">
              <div>
                <p class="ds-ui-2 ds-color-core-neutral-7">{{ investment.amount_committed_at | date: 'dd/MM/yyyy' }}</p>
                @if (badge.type !== 'hidden') {
                  <app-ds-badge [type]="badge.type">
                    {{ 'GROW.project.customerInvestmentStatus.' + badge.key + '.name' | translate }}
                  </app-ds-badge>
                }
              </div>
              <div>
                <p class="ds-ui-2 ds-color-core-neutral-10">{{ investment.amount | thousand: project.currency }}</p>
              </div>
            </div>
          </ng-template>
        </app-ds-info-row>
      }

      <app-ds-info-row [showCustomContent]="true">
        <ng-template #customContent>
          <div class="inyova-grow-investment">
            <div>
              <p class="ds-ui-2 ds-color-core-neutral-7">{{ 'GROW.project.investments.total' | translate }}</p>
            </div>
            <div>
              <p class="ds-heading-3 ds-color-core-neutral-10">{{ projectTotalInvestments | thousand: project.currency }}</p>
            </div>
          </div>
        </ng-template>
      </app-ds-info-row>
    </div>
  }

  @if (growAccount.step_status === accountStatusList.FUNDED && project.account_specific.transactions.length > 0) {
    <div class="inyova-grow-figures">
      <h2 class="ds-heading-1">{{ 'GROW.project.payments.transactions' | translate }}</h2>
      <div class="inyova-grow-payments">
        <!-- Interest received -->
        <app-ds-info-row
          [title]="
            ('GROW.project.payments.interestReceived' | translate) +
            ' (' +
            ((projectTransactionsDetails.alreadyReceivedInterestCount === 1
              ? 'GROW.project.payments.singlePayment'
              : 'GROW.project.payments.multiplePayments'
            ) | translate: { count: projectTransactionsDetails.alreadyReceivedInterestCount }) +
            ')'
          "
          [value]="projectTransactionsDetails.alreadyReceivedInterest.toFixed(2) | thousand: project.currency"
        >
        </app-ds-info-row>
        <!-- Total interest received -->
        <app-ds-info-row
          [title]="
            ('GROW.project.payments.interestExpected' | translate) +
            ' (' +
            ((projectTransactionsDetails.totalInterestCount === 1 ? 'GROW.project.payments.singlePayment' : 'GROW.project.payments.multiplePayments')
              | translate: { count: projectTransactionsDetails.totalInterestCount }) +
            ')'
          "
          [value]="projectTransactionsDetails.totalExpectedInterest.toFixed(2) | thousand: project.currency"
        >
        </app-ds-info-row>
      </div>
      <!-- Upcoming payments -->
      @if (projectTransactionsDetails.upcoming.length > 0) {
        @if (showMore['upcomingPayments']) {
          @for (coupon of projectTransactionsDetails.upcoming; track coupon) {
            @let badge = getCouponBadge(coupon.status);
            <app-ds-info-row [showCustomContent]="true">
              <ng-template #customContent>
                <div class="coupon-item">
                  <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.project.payments.' + coupon.type | translate }}</p>
                  <div>
                    <span class="ds-ui-3 ds-color-core-neutral-6">{{ coupon.payment_date | date: 'dd/MM/yyyy' }}</span>
                    @if (badge.type !== 'hidden') {
                      <app-ds-badge [type]="badge.type">
                        {{ 'GROW.project.payments.' + badge.key | translate }}
                      </app-ds-badge>
                    }
                  </div>
                </div>
                <div class="coupon-value">
                  <p class="ds-ui-2">{{ (+coupon.amount).toFixed(2) | thousand: project.currency }}</p>
                </div>
              </ng-template>
            </app-ds-info-row>
          }
        }
        <app-ds-info-row
          [showCustomContent]="true"
          [customStyle]="'background-color: var(--color-core-brand-3-2); padding-left: var(--spacing-3); padding-right: var(--spacing-3)'"
          (click)="showMore['upcomingPayments'] = !showMore['upcomingPayments']"
        >
          <ng-template #customContent>
            <div class="payment-section-collapse">
              <div>
                <p class="ds-ui-2 ds-color-core-neutral-10">{{
                  'GROW.project.payments.upcomingTransactions' | translate: { count: projectTransactionsDetails.upcoming.length }
                }}</p>
              </div>
              <div>
                <app-ds-icon size="icon-size-2" [name]="showMore['upcomingPayments'] ? 'chevron-up' : 'chevron-down'"></app-ds-icon>
              </div>
            </div>
          </ng-template>
        </app-ds-info-row>
      }

      <!-- Next payments -->
      @if (projectTransactionsDetails.next.length > 0) {
        @for (coupon of projectTransactionsDetails.next; track coupon) {
          @let badge = getCouponBadge(coupon.status);
          <app-ds-info-row [showCustomContent]="true">
            <ng-template #customContent>
              <div class="coupon-item">
                <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.project.payments.' + coupon.type | translate }}</p>
                <div>
                  <span class="ds-ui-3 ds-color-core-neutral-6">{{ coupon.payment_date | date: 'dd/MM/yyyy' }}</span>
                  @if (badge.type !== 'hidden') {
                    <app-ds-badge [type]="badge.type">
                      {{ 'GROW.project.payments.' + badge.key | translate }}
                    </app-ds-badge>
                  }
                </div>
              </div>
              <div class="coupon-value">
                <p class="ds-ui-2">{{ (+coupon.amount).toFixed(2) | thousand: project.currency }}</p>
              </div>
            </ng-template>
          </app-ds-info-row>
        }
      }

      <!-- Past payments -->
      @if (projectTransactionsDetails.past.length > 0) {
        <app-ds-info-row
          [showCustomContent]="true"
          [customStyle]="'background-color: var(--color-core-brand-3-2); padding-left: var(--spacing-3); padding-right: var(--spacing-3)'"
          (click)="showMore['pastPayments'] = !showMore['pastPayments']"
        >
          <ng-template #customContent>
            <div class="payment-section-collapse">
              <div>
                <p class="ds-ui-2 ds-color-core-neutral-10">{{
                  'GROW.project.payments.pastTransactions' | translate: { count: projectTransactionsDetails.past.length }
                }}</p>
              </div>
              <div>
                <app-ds-icon size="icon-size-2" [name]="showMore['pastPayments'] ? 'chevron-up' : 'chevron-down'"></app-ds-icon>
              </div>
            </div>
          </ng-template>
        </app-ds-info-row>
        @if (showMore['pastPayments']) {
          @for (coupon of projectTransactionsDetails.past; track coupon) {
            @let badge = getCouponBadge(coupon.status);
            <app-ds-info-row [showCustomContent]="true">
              <ng-template #customContent>
                <div class="coupon-item">
                  <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.project.payments.' + coupon.type | translate }}</p>
                  <div>
                    <span class="ds-ui-3 ds-color-core-neutral-6">{{ coupon.payment_date | date: 'dd/MM/yyyy' }}</span>
                    @if (badge.type !== 'hidden') {
                      <app-ds-badge [type]="badge.type">
                        {{ 'GROW.project.payments.' + badge.key | translate }}
                      </app-ds-badge>
                    }
                  </div>
                </div>
                <div class="coupon-value">
                  <p class="ds-ui-2">{{ (+coupon.amount).toFixed(2) | thousand: project.currency }}</p>
                </div>
              </ng-template>
            </app-ds-info-row>
          }
        }
      }
    </div>
  }

  <div class="inyova-grow-figures">
    <h2 class="ds-heading-1">{{ 'GROW.project.keyFigures' | translate }}</h2>

    <!-- Interest rate -->
    <app-ds-info-row
      [title]="'GROW.project.figure.expectedReturn' | translate"
      [value]="(project.expected_return | percent: '1.2') + ' ' + ('GROW.project.perAnnum' | translate)"
      [info]="'GROW.project.figureInfo.expectedReturn' | translate"
      (showInfoHandler)="trackTooltip('expectedReturn')"
    ></app-ds-info-row>
    <!-- Bonus payment -->
    <app-ds-info-row
      *ngIf="project.bonus_payment"
      [title]="'GROW.project.figure.bonusPayment' | translate"
      [value]="project.bonus_payment | percent: '1.2'"
      [info]="project.bonus_payment_info"
      (showInfoHandler)="trackTooltip('bonusPayment')"
    ></app-ds-info-row>
    <!-- Interest Schedule -->
    @if (growAccount.step_status !== accountStatusList.FUNDED || project.account_specific.transactions.length === 0) {
      <app-ds-info-row
        [title]="'GROW.project.figure.payout' | translate"
        [value]="'GROW.project.payout.' + project.payout | translate"
        [info]="'GROW.project.figureInfo.payout' | translate"
        (showInfoHandler)="trackTooltip('payout')"
      ></app-ds-info-row>
    } @else {
      <!-- Payment frequency -->
      <app-ds-info-row [title]="'GROW.project.payments.frequency' | translate" [value]="'GROW.project.payout.' + project.payout | translate">
      </app-ds-info-row>
    }
    <!-- Maturity -->
    <app-ds-info-row
      [title]="'GROW.project.figure.duration' | translate"
      [value]="('GROW.project.until' | translate | titlecase) + ' ' + (project.end_date | dateTranslate: 'shortDate' : language)"
      [info]="'GROW.project.figureInfo.duration' | translate"
      (showInfoHandler)="trackTooltip('duration')"
    ></app-ds-info-row>
    <!-- Min. Funding -->
    <app-ds-info-row
      [title]="'GROW.project.figure.minInvestmentAmount' | translate"
      [value]="project.minimum_funding | thousand: project.currency"
      [info]="'GROW.project.figureInfo.minInvestmentAmount' | translate"
      (showInfoHandler)="trackTooltip('minInvestmentAmount')"
    ></app-ds-info-row>
    <!-- Currency -->
    <app-ds-info-row
      [title]="'GROW.project.figure.currency' | translate"
      [value]="project.currency"
      [info]="'GROW.project.figureInfo.currency' | translate"
      (showInfoHandler)="trackTooltip('currency')"
    ></app-ds-info-row>
    <!-- Deadline -->
    <app-ds-info-row
      *ngIf="project.deadline"
      [title]="'GROW.project.figure.fundingEnds' | translate"
      [value]="project.deadline | dateTranslate: 'shortDate' : language"
      [info]="'GROW.project.figureInfo.fundingEnds' | translate"
      (showInfoHandler)="trackTooltip('fundingEnds')"
      style="text-transform: capitalize"
    ></app-ds-info-row>
    <!-- Total Volume -->
    <app-ds-info-row
      [title]="'GROW.project.figure.totalVolume' | translate"
      [value]="project.total_volume | thousand: project.currency"
      [info]="'GROW.project.figureInfo.totalVolume' | translate"
      (showInfoHandler)="trackTooltip('totalVolume')"
    ></app-ds-info-row>
    <!-- Asset Type -->
    <app-ds-info-row
      [title]="'GROW.project.figure.assetType' | translate"
      [value]="project.asset_type"
      [info]="'GROW.project.figureInfo.assetType' | translate"
      (showInfoHandler)="trackTooltip('assetType')"
    ></app-ds-info-row>
    <!-- Sector -->
    <app-ds-info-row
      [title]="'GROW.project.figure.category' | translate"
      [value]="project.sector"
      [info]="'GROW.project.figureInfo.category' | translate"
      (showInfoHandler)="trackTooltip('category')"
    ></app-ds-info-row>
    <!-- Location -->
    <app-ds-info-row
      [title]="'GROW.project.figure.location' | translate"
      [value]="project.location"
      [info]="'GROW.project.figureInfo.location' | translate"
      (showInfoHandler)="trackTooltip('location')"
    ></app-ds-info-row>
    <!-- Issuer -->
    <app-ds-info-row
      [title]="'GROW.project.figure.issuer' | translate"
      [value]="project.issuer"
      [info]="'GROW.project.figureInfo.issuer' | translate"
      (showInfoHandler)="trackTooltip('issuer')"
    ></app-ds-info-row>
  </div>

  <app-ds-content-switcher type="medium" [activeTab]="activeTab" [tabs]="switcherTabs" (tabSwitched)="switchTabs($event)"></app-ds-content-switcher>

  <div class="inyova-grow-project-content" [ngSwitch]="activeTab">
    <ng-container *ngSwitchCase="tabList.DETAILS">
      <div [innerHTML]="project.description"></div>
      <h3>{{ 'GROW.project.documents.title' | translate }}</h3>
      <app-inyova-grow-project-doc [doc]="project.fact_sheet" [title]="'GROW.project.documents.factSheet' | translate"></app-inyova-grow-project-doc>
      <app-inyova-grow-project-doc
        [doc]="project.terms_conditions_sheet"
        [title]="'GROW.project.documents.termsConditionsSheet' | translate"
      ></app-inyova-grow-project-doc>
      <app-inyova-grow-project-doc [doc]="project.term_sheet" [title]="'GROW.project.documents.termSheet' | translate"></app-inyova-grow-project-doc>
    </ng-container>

    <ng-container *ngSwitchCase="tabList.OPPORTUNITIES">
      <div [innerHTML]="project.opportunities_description"></div>
    </ng-container>

    <ng-container *ngSwitchCase="tabList.RISKS">
      <div [innerHTML]="project.risk_description"></div>
    </ng-container>

    <ng-container *ngSwitchCase="tabList.IMPACT">
      <div [innerHTML]="project.impact_description"></div>
    </ng-container>
  </div>

  <app-ds-callout
    variant="warning"
    [title]="'GROW.project.warning.title' | translate"
    [description]="'GROW.project.warning.body' | translate"
  ></app-ds-callout>

  <app-ds-callout
    *ngIf="project.currency.toLowerCase() !== growAccount.currency.toLowerCase()"
    variant="info"
    [title]="'GROW.project.currencyDisclaimer.title' | translate: { currency: project.currency }"
    [description]="'GROW.project.currencyDisclaimer.body' | translate"
  ></app-ds-callout>
</div>
